module.exports = __webpack_public_path__ + "static/media/user-nft-22.b5e22870.jpg";